import { cn } from "@/lib/utils";
import { useDispatch } from "react-redux";

import { useSticky } from "../../../hooks/useSticky";
import {
  Alert as AlertType,
  removeAlert,
} from "../../../redux/message/messageSlice";
import { AppDispatch } from "../../../redux/store";
import {
  UserNotification,
  markNotificationAsRead,
} from "../../../redux/user/userSlice";
import { Alert } from "./Alert/Alert";
import { UserNotifcation } from "./UserNotification/UserNotification";

type Props = {
  userNotifications: UserNotification[];
  alerts: AlertType[];
};
export const Notifications = ({ userNotifications, alerts }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const [hasReachedRef, stickyRef] = useSticky({
    triggerOn: "bottom",
  }) as [boolean, React.MutableRefObject<HTMLDivElement>];

  return (
    <>
      <div
        className="absolute top-0 text-white touch-device:h-[80px]"
        ref={stickyRef}
      />
      <div
        className={cn(
          "z-50 flex flex-col right-4 left-4 mobile:left-auto gap-y-2 touch-device:gap-y-4 top-4 items-end",
          hasReachedRef || window.scrollY > 80
            ? "fixed "
            : "fixed touch-device:absolute touch-device:top-24",
        )}
      >
        {userNotifications.map(
          (notification) =>
            notification && (
              <UserNotifcation
                key={notification.id}
                notification={notification}
                onHandleClose={() => {
                  dispatch(
                    markNotificationAsRead({
                      notificationId: notification.id,
                    }),
                  );
                }}
              />
            ),
        )}
        <div className="relative">
          {alerts.map((alert, index) => (
            <Alert
              alert={alert}
              key={alert.id}
              stackIndex={alerts.length - 1 - index}
              onHandleClose={() => {
                dispatch(removeAlert(alert.id));
              }}
            />
          ))}
        </div>
      </div>
    </>
  );
};
